import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { ScrollToTop } from "./components/ScrollToTop";
import { Accueil } from "./pages/Accueil";
import { Isolation } from "./pages/Isolation";
import { OssatureBois } from "./pages/OssatureBois";
import { Menuiserie } from "./pages/Menuiserie";
import { Contact } from "./pages/Contact";
import { MentionsLegales } from "./pages/MentionsLegales";
import { PolitiqueConfidentialite } from "./pages/PolitiqueConfidentialite";

function App() {
  return (
    <div className="App min-h-screen bg-[#0a0908]">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Accueil />} />
            <Route path="/isolation" element={<Isolation />} />
            <Route path="/ossature-bois" element={<OssatureBois />} />
            <Route path="/menuiserie" element={<Menuiserie />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/mentions-legales" element={<MentionsLegales />} />
            <Route path="/politique-confidentialite" element={<PolitiqueConfidentialite />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
